module.exports = __webpack_public_path__ + "img/close.52176ba0.svg";